import React from "react";
import { Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import { fileUrl, formatFCFA } from "@/lib/api";

export default function HeroCarousel({ products = [] }) {
  // Only in-stock products with at least one photo
  const inStock = products
    .filter((p) => p.stock > 0 && p.photos && p.photos.length > 0)
    .map((p) => ({ ...p, _photo: p.photos[0].path }));

  if (inStock.length === 0) return null;

  // Duplicate to ensure marquee has enough content for smooth loop
  const displayItems = inStock.length < 5 ? [...inStock, ...inStock, ...inStock] : inStock;

  return (
    <section
      className="relative bg-[#FAF7F0] border-y border-[#B8860B]/20 py-10"
      data-testid="hero-carousel"
      aria-label="Pièces en vedette"
    >
      <div className="px-4 sm:px-6 lg:px-10 mb-6 flex items-center justify-between max-w-7xl mx-auto">
        <div className="label-tiny flex items-center gap-3">
          <span className="gold-line" /> Pièces disponibles
        </div>
        <Link
          to="/catalogue"
          className="text-[10px] sm:text-xs uppercase tracking-[0.25em] text-[#B8860B] hover:text-[#FFE9A6] transition-colors"
        >
          Tout voir →
        </Link>
      </div>

      <Marquee speed={30} gradient={false} pauseOnHover autoFill={false}>
        {displayItems.map((p, i) => (
          <Link
            key={`${p.id}-${i}`}
            to={`/produit/${p.id}`}
            data-testid={`hero-carousel-item-${p.id}`}
            className="block mx-3 group"
          >
            <div className="relative w-[280px] sm:w-[320px] aspect-[3/4] overflow-hidden border border-[#B8860B]/40 hover:border-[#B8860B] transition-colors">
              <img
                src={fileUrl(p._photo)}
                alt={p.name}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              {/* Dark gradient overlay for legibility */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
              {/* Gold overlay text */}
              <div className="absolute bottom-0 inset-x-0 p-5">
                <div className="font-display text-lg lg:text-xl text-[#FFE9A6] leading-tight line-clamp-2">
                  {p.name}
                </div>
                <div className="mt-2 flex items-center justify-between">
                  <span className="text-[#B8860B] font-medium text-sm tracking-wide">
                    {formatFCFA(p.price)}
                  </span>
                  <span className="text-[10px] uppercase tracking-[0.25em] text-[#FFE9A6] opacity-80 group-hover:opacity-100">
                    Découvrir →
                  </span>
                </div>
              </div>
              {/* Gold corner accents */}
              <div className="absolute top-0 left-0 w-6 h-6 border-t-2 border-l-2 border-[#B8860B]" />
              <div className="absolute top-0 right-0 w-6 h-6 border-t-2 border-r-2 border-[#B8860B]" />
              <div className="absolute bottom-0 left-0 w-6 h-6 border-b-2 border-l-2 border-[#B8860B]" />
              <div className="absolute bottom-0 right-0 w-6 h-6 border-b-2 border-r-2 border-[#B8860B]" />
            </div>
          </Link>
        ))}
      </Marquee>
    </section>
  );
}
